<template>
  <!--  sidebar-class="border-right border-danger"-->
  <!--       class="add-publishing" -->
  <b-sidebar
    :id="sbId"
    :visible="sbModel"
    right
    shadow
    lazy
    :no-header="true"
    :no-close-on-backdrop="false"
  >
    <b-card
        v-if="settings"
      style="height:100vh
"
    >
      <b-alert
          variant="warning"
          dismissible
          :show="showWarning"
      >
        {{warningMsg}}
      </b-alert>
      <template #header>
        <b-row>
          <b-col cols="9"><h3>Solitudes</h3></b-col>
          <b-col>
            <span class="ico"
                  style="cursor: pointer"
                  @click="handleCloseSideBar">
          <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#E4E6EB" />
            <g clip-path="url(#clip0)">
              <path
                  d="M16.7855 16.0008L22.9482 9.83807C23.1652 9.6211 23.1652 9.26932 22.9482 9.05238C22.7312 8.83543 22.3794 8.83541 22.1625 9.05238L15.9998 15.2151L9.83709 9.05238C9.62012 8.83541 9.26834 8.83541 9.0514 9.05238C8.83446 9.26935 8.83443 9.62113 9.0514 9.83807L15.2141 16.0008L9.0514 22.1635C8.83443 22.3804 8.83443 22.7322 9.0514 22.9492C9.15987 23.0576 9.30207 23.1119 9.44426 23.1119C9.58646 23.1119 9.72862 23.0576 9.83712 22.9492L15.9998 16.7865L22.1625 22.9492C22.2709 23.0576 22.4131 23.1119 22.5553 23.1119C22.6975 23.1119 22.8397 23.0576 22.9482 22.9492C23.1652 22.7322 23.1652 22.3804 22.9482 22.1635L16.7855 16.0008Z"
                  fill="#606770"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                    width="14.2222"
                    height="14.2222"
                    fill="white"
                    transform="translate(8.88867 8.88892)"
                />
              </clipPath>
            </defs>
          </svg>
        </span></b-col>
        </b-row>
      </template>



      <b-card v-if="!production" class="mt-3" header="Form Data Result">
        <pre class="m-0">{{ form }}</pre>
      </b-card>
    </b-card>
    <template #footer>
      <div style="background-color: yellow">

      </div>
    </template>
    <div></div>
  </b-sidebar>
</template>
<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import moment from "moment";
import UploadImage from "@/mixins/UploadImage";
import ImageUpload from "@/components/common/imageUpload";
import Editor from "@/components/common/editor";

import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import AudioRecorder from "@/components/blockResources/_components/audioRecorder";
import LabelInfo from "@/components/blockResources/_components/labelInfo";
import ToggleSingle from "@/components/blockResources/_components/toggleSingle";
export default {
  name: "Bend_FormSideBar",
  mixins: [UploadImage],
  components: {
    ImageUpload,
    Editor,
    AudioRecorder,
    VueBootstrapTypeahead,
    LabelInfo,
    ToggleSingle
  },
  props: {
    sbId: {
      type: String,
      required: true
    },
    sbModel: {
      type: Boolean,
      required: true
    },
    resource: {
      type: Object,
      required: ()=>{return {}}
    },
    settings: {
      type: Object,
      required: ()=>{return {}}
    },
    items: {
      type: Array,
      default: () => [],
      required: false
    },
    assetsUrlHome: {
      type: String,
      default: "",
      required: false
    },
    updatedAt: {
      type: String,
      default: "",
      required: false
    }
  },
  created() {},
  mounted() {
    this.resetForm(); //@TODO do I need to deepclone ?
    //Time

    this.form._created_at = new Date();
    this.createdBy = this.form._created_by;
    this.createdBy.uid = this.profile.userId ? this.profile.userId : null;
    this.createdBy.name = `${this.profile.firstname} ${this.profile.lastname}`;
    this.createdBy.imgURL = this.profile.imgURL;


    //Check for any needs and give alert if necessary
    if (!this.localeInfo.isSet && false) {
      this.warningMsg="Please set your locale so that we can provide the correct calendar"
      this.showWarning = true;
    }
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile",
      apps: "user/apps",
      userData: "user/appsData"
    }),
    settings_hasEndDate() {
      return this.settings && this.settings.user
          ? this.settings.user._hasEndDate
          : true;
    },
    settings_hasTimeToTake() {
      return this.settings && this.settings.user
          ? this.settings.user._hasTimeToTake
          : true;
    },
    settings_hasPrescriptionInfo() {
      return this.settings && this.settings.user
          ? this.settings.user._hasPrescriptionInfo
          : true;
    },
    settings_hasMedicationImage() {
      return this.settings && this.settings.user
          ? this.settings.user._hasMedicationImage
          : true;
    },
    settings_hasNotes() {
      return this.settings && this.settings.user
          ? this.settings.user._hasNotes
          : true;
    },
    settings_hasRefillReminders() {
      return this.settings && this.settings.user
          ? this.settings.user._hasRefillReminders
          : true;
    },
    settings_hasPharmacyInfo() {
      return this.settings && this.settings.user
          ? this.settings.user._hasPharmacyInfo
          : true;
    },
    settings_hasDosageForm() {
      return this.settings && this.settings.user
          ? this.settings.user._hasDosageForm
          : true;
    },
    settings_hasNotification() {
      return this.settings && this.settings.user
          ? this.settings.user._hasNotification
          : true;
    },
    settings_hasPurpose() {
      return this.settings && this.settings.user
          ? this.settings.user._hasPurpose
          : true;
    },
    settings_hasAllergies() {
      return this.settings && this.settings.user
          ? this.settings.user._hasAllergies
          : true;
    },
    settings_hasStorageInstructions() {
      return this.settings && this.settings.user
          ? this.settings.user._hasStorageInstructions
          : true;
    },
    settings_hasSideEffects() {
      return this.settings && this.settings.user
          ? this.settings.user._hasSideEffects
          : true;
    },
    settings_hasEmergencyContact() {
      return this.settings && this.settings.user
          ? this.settings.user._hasEmergencyContact
          : true;
    },
    settings_hasTags() {
      return this.settings && this.settings.user
          ? this.settings.user._hasTags
          : true;
    },
    settings_hasMedicationHistory() {
      return this.settings && this.settings.user
          ? this.settings.user._hasMedicationHistory
          : true;
    },
    /***TIME - move to top Level component */
    time() {
      return this.hours + ":" + this.minutes + ":" + this.seconds;
    },
    milliseconds: function() {
      return this.currentTime;
    },
    hours: function() {
      var milli = this.milliseconds;
      // Doing the math
      // var hrs = Math.floor((milli / 3600000) % 24);
      // Using getHours()
      var hrs = new Date().getHours();
      if (hrs >= 13) {
        hrs = hrs - 12;
      }
      return hrs >= 10 ? hrs : "0" + hrs;
    },
    minutes() {
      var milli = this.milliseconds;
      var min = Math.floor((milli / 60000) % 60);
      return min >= 10 ? min : "0" + min;
    },
    seconds() {
      var milli = this.milliseconds;
      var sec = Math.ceil((milli % 60000) / 1000).toFixed(0);
      //if (sec == 60) { sec = 00 }
      return sec >= 10 ? sec : "0" + sec;
    },
    day() {
      return "TUESDAY";
    },
    timeOfDay() {
      return "morning";
    },
    date() {
      //Settings could ask o
      return moment(Date.now())().format("MM/DD/YYYY");
    },
    /**** Validations ****/
    state() {
      return true;
    },
    invalidFeedback() {
      if (false) {
        return "Enter at least 4 characters.";
      }
      return "Please enter something.";
    },
    /* USERDATA */
    titleDate() {
      //"dddd, MMMM DD  YYYY"
      return moment(new Date()).format("MMMM DD YYYY");
    },
  },
  methods: {
    handleMedicationTypeAheadClick(event){
      //$event => (medication = $event.text)
      debugger;
      //Bring in as much info as possible, e.g. notes
      this.form.medicationName = event.text;
      this.form.images.medicationImage.imgURL = event.imgURL
    },
    handleToggleClick() {
      this.form._isCurrentlyTaking = !this.form._isCurrentlyTaking;
    },
    /**/
    handleAudioRecordedInfoByCreatedBy(info){
      debugger;
      if(this.form && this.form.audio){
        this.form.audio = info;
      }
      this.form._added_audio_at = new Date();
    },
    handleAddDocToggle() {
      this.addDocument = !this.addDocument;
    },
    handleImgUploadedMedicationImgURL(idx, url) {
      debugger;
      if(this.form && this.form.images && this.form.images.medicationImage &&
          this.form.images.medicationImage) {
        this.form.images.medicationImage.imgURL = url;
        this.form.images.medicationImage._created_at = new Date();
        this.form.images.medicationImage._created_by = this.createdBy;
      }
    },
    handleImgUploadedMedicationLabelURL(idx,url) {
      if(this.form && this.form.images && this.form.images.medicationLabel &&
          this.form.images.medicationLabel) {
        this.form.images.medicationLabel.imgURL = url;
        this.form.images.medicationLabel._created_at = new Date();
        this.form.images.medicationLabel._created_by = this.createdBy;
      }
    },
    resetForm() {
      debugger;
      this.form = null;
      this.form = _.clone(this.defaultForm);
    },
    input(val) {
      this.form.note = val.content;
    },
    handleItemClick(item) {
      this.$emit("item-clicked", item);
    },
    handleSaveClick() {
      debugger;
      this.$emit("med-form-click", this.form);
      this.resetForm();
      this.handleCloseSideBar();
    },
    handleStartEndCallClick() {
      this.callStarted = !this.callStarted;
      if (this.callStarted) {
        this.form._started_at.push[Date.now()];
      } else {
        this.form._ended_at.push[Date.now()];
      }
    },
    handleOpenSideBar() {
      this.sidebarModel = true;
    },
    handleCloseSideBar() {
      this.$emit("close-clicked");
    },
    resetClear() {
      this.clear = false;
    }
  },
  data() {
    return {
      production: true,
      createdBy: null,
      storagePath: "app_medication_images",
      assetURLPath:"/assets/apps/",
      localeInfo: this.profile && this.profile.about && this.profile.about.locale ?
          { locale: this.profile.about.locale, isSet: true } :
          {locale: "en-US", isSet: false},
      showWarning: false,
      warningMsg: "Please set your locale in settings > settings",
      callStarted: false,
      duration: 0,
      /*** TIME ***/
      timePolling: null,
      currentTime: Date.now(),
      changes: null,
      /*** TIME****/
      addDocument: false,
      idx: 0,
      docs: [],
      clear: false,
      form: {},
      defaultForm: {
        _created_at: null,
        _started_at: [],
        _ended_at: [],
        _isCurrentlyTaking: false,
        medicationName: "",
        dosage: "",
        frequency:"",
        _start_date_at:"",
        _end_date_at:"",
        timesToTake:[],
        prescriptionInfo:"",
        images:{
              medicationImage:{
                imgURL:"",
                _created_at:""
              },
          medicationLabel:{
            imgURL:"",
            _created_at:""
          },
        },
        notes:[],
        refillReminders:[],
        pharmacIbfo:{name:"",
               location:"",
                url:""
        },
        medicationCtegory:"",
        sideEffects:[],
        _created_by: {
          uid: "",
          name: "",
          imgURL: "",
        }
      },
      callPriorityOpt:[
        {
          "value": "urgent",
          "text": "Urgent",
          "color":"red",
          "_created_at": 1234
        },
        {
          "value": "high",
          "text": "High",
          "_created_at": 1234
        },
        {
          "value": "medium",
          "text": "Medium",
          "_created_at": 1234
        },
        {
          "value": "low",
          "text": "Low",
          "_created_at": 1234
        }
      ],
      /* SLIDE INFO*/
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.toggle-button {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  p {
    margin-left: 16px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: #474d52;
    margin: 0;
    margin-left: 16px;
    span {
      padding-left: 8px;
    }
  }
}
.toggler {
  position: relative;
  display: inline-block;
  width: 46.5px;
  height: 24px;
  background: #f3f6f9;
  border-radius: 18px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  cursor: pointer;
  @media (max-width: 590px) {
    margin-left: 15px;
  }
}
.slider {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: #b3c2cb;
  box-shadow: 0px 3px 9px #c4c4c4;

  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}
.bg {
  background: rgba(85, 126, 251, 0.1);
}
.btns {
  left: 50%;
  background: var(--theme-color);
  box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
}
</style>
